<template>
  <div
    :class="[
      'tw-w-full',
      {
        'sm:tw-w-[48%] lg:tw-w-full': !resourceEditable,
      },
    ]"
  >
    <button :disabled="disabled" class="button button-block button-outlined" @click="loadPreview">
      Preview File
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PreviewButton',
  props: {
    resourceId: { type: Number, default: null },
    resourceEditable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: false,
      previewString: '',
    };
  },
  computed: {
    ...mapGetters(['resource', 'loggedInUser']),
  },
  methods: {
    async loadPreview() {
      try {
        if (!this.previewString) {
          const response = await this.$axios.$get('/public/v1/resource/preview', {
            params: { id: this.resourceId },
          });
          this.previewString = response;
        }
        this.$store.dispatch('toggleResourcePreview', this.previewString);
        this.eventResourcePreviewed();
      } catch (error) {
        console.error(error);
        this.$store.dispatch('setToast', {
          content: 'Something went wrong trying to preview this resource. Please try again later.',
        });
      }
    },
    eventResourcePreviewed() {
      if (!this.resource.event_params) {
        return;
      }

      if (this.resource.event_params.Page_Type_Name === 'Teaching Resource') {
        this.$mzAnalyticsApi({
          event: 'click',
          name: 'resource.preview',
          productArea: 'resources',
          entityType: this.resource.type,
          entityId: this.resource.id,
        });
      }
    },
  },
};
</script>
